<template>
	<div class="header-wrapper" >
		<div class="header">
			<div style="display: flex; flex-direction: column;">
				<div class="header-mid" style="margin: 0;">
					<div :class="show_edit_icon" style="display: none; justify-content: center;margin-right: 20px; ">
						<a :href="$globalConfigApiHost+'/items/manage/edit/'+itemId_header_info" target="_blank" >
							<img src="../../../assets/images/help/edit.svg" alt="直达编辑页" title="点此图片,直达编辑页">
						</a>
					</div>
					
					<div class="header-img">
						<!-- <img :src="$globalConfigFileHost+itemVOList[0].itemValue" alt=""> --> <!-- ../../../assets/images/logo.png -->
						<!-- <img src="../../../assets/images/logo.png" alt=""> --> <!-- ../../../assets/images/logo.png -->
						<img :src="companyIcon" alt=""> <!-- ../../../assets/images/logo.png -->
					</div>
					
					<div class="header-item">
						<i :style="{color: headerIconColor}" class="contact-icon am-icon-phone"></i>
						<div class="item">
							<strong :style="{color: headerFontColor}">{{itemVOList[0].itemName}} <!-- 15284734573 --></strong>
							<span :style="{color: headerFontColor}">{{itemVOList[0].itemValue}} <!-- 周一 ~ 周五, 8:30 - 17:30 --></span>
						</div>
					</div>
					<div class="header-item">
						<i :style="{color: headerIconColor}"class="contact-icon am-icon-map-marker"></i>
						<div class="item">
							<strong :style="{color: headerFontColor}">{{itemVOList[1].itemName}}</strong> <!-- 四川省成都市高新区 -->
							<span :style="{color: headerFontColor}">{{itemVOList[1].itemValue}} <!-- 四川XXXX有限公司 --></span>
						</div>
					</div>
				
					<div :class="show_edit_icon" style="display: none; justify-content: center; ">
						<a :href="$globalConfigApiHost+'/items/manage/edit/'+itemId_header_info" target="_blank" >
							<img src="../../../assets/images/help/edit.svg" alt="直达编辑页" title="点此图片,直达编辑页">
						</a>
					</div>
				
					<div class="header-item header-right">
						<router-link to="/c" class="">  <!-- tel:+18583266628 -->
							<!-- <button :style="{color:headerBottomColor, borderBlockColor: headerBottomColor}" type="button" >{{itemVOList[1].itemAlias}}</button> -->
							<button type="button" >{{itemVOList[1].itemAlias}} <!-- 联系我们 --></button>
						</router-link>
					</div>
				
					<div class="header-item header-right">
						<router-link to="/d" class="">
							<button type="button" >下载移动客户端</button>
						</router-link>
					</div>
				</div>
			</div>
			
			
		</div>
		
		<div class="nav-wrapper header-default">
			<div class="nav">
				<ul class="am-nav am-nav-pills am-nav-justify"><!-- 网站首页、产品中心、客户案例、公司动态、关于我们、 -->
					<!-- <li><router-link class="router" :to="menuList[0].pagePath">{{menuList[0].pageName}}</router-link></li>
					<li><router-link class="router" :to="menuList[1].pagePath">{{menuList[1].pageName}}</router-link></li>
					<li><router-link class="router" :to="menuList[2].pagePath">{{menuList[2].pageName}}</router-link></li>
					<li><router-link class="router" :to="menuList[3].pagePath">{{menuList[3].pageName}}</router-link></li>
					<li><router-link class="router" :to="menuList[4].pagePath">{{menuList[4].pageName}}</router-link></li> -->
					
					 
					<!-- 网站首页、产品中心、客户案例、公司动态、关于我们、 -->
					<!-- <li v-for="n in menuLength" :key="n">
						<router-link class="router" :to="`${menuMap['itemIndex'+(n-1)].itemValue}`">{{menuMap['itemIndex'+(n-1)].itemName}}</router-link>
					</li> -->
					<li v-for="(menu, index) in menuList" >
						<!-- <router-link class="router" style="background-color: white;" :to="`${ menu.pagePath}`">
							{{menu.pageName}}
						</router-link> -->
						<router-link  :to="{path: `${ menu.pagePath}`, query: routerQuery()}" class="link">
							{{menu.pageName}} 
						</router-link>
					</li>
					
					
					<li :class="hidden_menu_edit_icon">
						<div :class="show_edit_icon" style="display: none; justify-content: center; ">
							<a :href="$globalConfigApiHost+'/product/productType/productTypeSimple' " target="_blank" >
								<img src="../../../assets/images/help/edit.svg" alt="直达编辑页" title="点此图片,直达编辑页">
							</a>
						</div>
					</li>
					
					<li class="searchInput" style="max-width: 1px; min-height: 50px; justify-content: center; align-items: center;" >
						<el-row :gutter="20" style="display: flex;  border-radius: 5px;" >
							<el-col style="margin-bottom: 7px;">
								<lilo-group-select @change="groupSelectChange" :multiple="false" :likeQuery="true" :searchApi="'/api/list/search'" clearable placeholder="请输入快速搜索" ></lilo-group-select>
							</el-col>
						</el-row>
						
					</li>
				</ul>
				
			</div>
		</div>
		
	</div>
</template>

<script>
import AppFunctions from "@/utils/AppFunctions";
import LiloGroupSelect from "@/components/common/help/ElementUIGroupSelect";
import {postRequest} from "@/api/api";

export default {
	name: "Header",
	components: {
		LiloGroupSelect
	},
	created() {
		window.addEventListener('scroll', this.toggleStickyHeader);
	},
	mounted() {
		this.showEditIcon(this.getUrlKey('showEditIcon'));
		this.getItemList();
		this.toggleStickyHeader();
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.toggleStickyHeader);
	},
	data(){
		return{
			AppFunctions,
			companyIcon: "",
			HeaderBackgroundColor: "",
			headerFontColor: "red",
			headerIconColor: "#7c6aa6",
			// headerBottomColor: "#7c6aa6",
			itemVOList:[
				{itemIndex:0, itemName:"", itemValue:"", itemAlias:"", itemDetail:""}, 
				{itemIndex:0, itemName:"", itemValue:"", itemAlias:"", itemDetail:""}, 
				// itemIndex2:{itemName:"", itemValue:"", itemAlias:"", itemDetail:""}, 
				// itemIndex3:{itemName:"", itemValue:"", itemAlias:"", itemDetail:""},
			],
			// itemVOList:[
			// 	{pagePath:"", pageName:""}, 
			// 	{pagePath:"", pageName:""}, 
			// 	// itemIndex2:{itemName:"", itemValue:"", itemAlias:"", itemDetail:""}, 
			// 	// itemIndex3:{itemName:"", itemValue:"", itemAlias:"", itemDetail:""},
			// ],
			menuList:[
				{pagePath:"", pageName:""}, 
				{pagePath:"", pageName:""}, 
				{pagePath:"", pageName:""}, 
				{pagePath:"", pageName:""}, 
				{pagePath:"", pageName:""}, 
			],
			itemId_header_info: 0,
			// itemId_menu_info: 0,
			// menuLength: 0,
			// inputValue: '',
			groupSelectOptions: [
				{
					id: 1,
					label: '热门城市',
					checked: false,
					isIndeterminate: false,
					options: [
						{
							value: 'Shanghai',
							label: '上海'
						},
						{
							value: 'Beijing',
							label: '北京'
						}
					]
				},
				{
					id: 2,
					label: '城市名',
					checked: false,
					isIndeterminate: false,
					options: [
						{
							value: 'Chengdu',
							label: '成都'
						},
						{
							value: 'Shenzhen',
							label: '深圳'
						}
					]
				}
			],
			groupSelectOptions2: [
				{
					id: 1,
					label: '超期',
					options: [
						{
							value: 'cqwbj',
							label: '超期未办结'
						},
						{
							value: 'ycq',
							label: '已超期'
						}
					]
				},
				{
					id: 2,
					label: '按天',
					options: [
						{
							value: 't1',
							label: '1天'
						},
						{
							value: 't2',
							label: '2天'
						},
						{
							value: 't3',
							label: '3天'
						}
					]
				},
				{
					id: 3,
					label: '按小时',
					options: [
						{
							value: 'h1',
							label: '1小时'
						},
						{
							value: 'h2',
							label: '2小时'
						}
					]
				}
			],
		}
	},
	methods: {
		getItemList(){
			// this.getRequest("/api/list/items", {typeKeys:"'m_0_1_header_info','m_0_0_menu_info'"}).then(resp =>{
			this.getRequest("/api/list/items", {typeKeys:"'m_0_1_header_info'", isEnabled: 0}).then(resp =>{
				if (resp){
					this.itemVOList = resp.m_0_1_header_info.itemVOList
					this.itemId_header_info = resp.m_0_1_header_info.cid
					this.companyIcon = this.itemVOList[0].itemDetail
					var secondItem = this.itemVOList[2]
					this.headerFontColor = secondItem.itemValue
					this.headerIconColor = secondItem.itemDetail
					// this.headerBottomColor = this.itemVOList[1].itemDetail
				}
			});
			var equipment = navigator.userAgent
			equipment.length>255?equipment=equipment.substring(0, 255):equipment;
			postRequest("/api/list/menu", {equipment: equipment}).then(resp =>{
				if (resp){
					this.menuList = resp
				}
			});
		},
		toggleStickyHeader() {
			const scrolled = document.documentElement.scrollTop;
			if (scrolled > 100) {
				AppFunctions.addClass('.header-default', 'sticky');
			} else if (scrolled <= 100) {
				AppFunctions.removeClass('.header-default', 'sticky');
			}
		},
		
		getUrlKey(name){
		   return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
		},
		groupSelectChange(option) {
			console.log("下拉选项选中："+JSON.stringify(option));
			if(option==''|| option.srcPath=='')return;
			// this.$router.push(option.srcPath);
			this.$router.push(option.srcPath).catch(err => {
				if (err.name !== 'NavigationDuplicated') {
					// 处理其他可能的错误
					// console.error(err);
				}
				// 对于 NavigationDuplicated 错误，可以选择不做任何处理
			});
		},
		
		routerQuery(){
			if(this.$route.query.showEditIcon) return {showEditIcon: this.$route.query.showEditIcon}
			return {}
		},
	},
	
}
</script>

<style scoped>
	
.router.router-link-active{
	/* color: #fff; */
/* 	background-color: #0e90d2;
	border: 1px solid #0e90d2; */
	cursor: default;
	
	color: #0e90d2;
}
	
.bm-view {
  /* width: 100%; */
  min-width: 300px;
  height: 100px;
}

.header-wrapper .nav-wrapper .header-default{
	display: flex;
	flex-direction: column;
}

.header-wrapper .nav-wrapper .header-default .nav{
	display: flex;
	flex-direction: column;
}

/* 当屏幕宽度小于768px时（移动设备） */
@media screen and (max-width: 768px) {
  .header-wrapper .nav-wrapper .nav ul {
    flex-wrap: wrap; /* 允许菜单项换行 */
    justify-content: center; /* 居中对齐 */
  }
  
  .searchInput {
    order: 999; /* 确保搜索框在最后显示 */
    flex-basis: 100%; /* 占据整行 */
    max-width: 100% !important; /* 覆盖原有的最大宽度 */
    min-height: auto !important; /* 调整最小高度 */
    margin-top: -20px; /* 添加上边距 */
    justify-content: center !important;
    display: flex !important;
	width: 600px;
  }
  
  .searchInput .el-row {
    width: 90%; /* 控制搜索框宽度 */
    max-width: 200px; /* 设置最大宽度 */
  }
}

</style>
